import PageHeadline from '../../../components/molecules/headlines/PageHeadline'
export default {
  components: { PageHeadline },
  data() {
    return {
      nickname: '',
      isNicknameFocused: false,
      email: '',
      isEmailFocused: false,
      gender: '',
      birthYear: '',
      birthMonth: '',
      birthDay: '',
      isInformationMailChecked: true,
      isUsableGiftChecked: true,
      hasErrors: false
    }
  },
  created() {
    const errorMessage = document.querySelector('.error_message')
    if (errorMessage) {
      this.hasErrors = true
      this.enterError()
    }
    // バリデーションエラーになって Rails で render :new され、 registration.js がマウントされた後、
    // v-model で設定している各要素に registration.js の初期値がセットされるのを防ぐための処理
    // Vue.js のディレクティブをカスタマイズしてトライするも意図する形に実装できなかったので、一旦 DOM をみるアプローチで実装する
    // ref:
    // https://jp.vuejs.org/v2/guide/custom-directive.html
    // https://stackoverflow.com/questions/47885443/set-initial-value-to-vue-js-model-which-is-directly-available-in-html
    // https://qiita.com/kuroda@github/items/940338b5f6f46da2c5f1
    const nicknameHtml = document.querySelector(
      '#user_registration_form_nickname'
    ).outerHTML
    const nickname = nicknameHtml.match(/value="(.*?)"/)
    if (nickname) {
      this.nickname = nickname[1]
    }
    const emailHtml = document.querySelector('#user_registration_form_email')
      .outerHTML
    const email = emailHtml.match(/value="(.*?)"/)
    if (email) {
      this.email = email[1]
    }
    document
      .getElementsByName('user_registration_form[gender]')
      .forEach(node => {
        if (node.checked) {
          this.gender = node.value
        }
      })
    const birthYear = document.querySelector(
      '#user_registration_form_birth_year'
    ).value
    if (birthYear) {
      this.birthYear = birthYear
    }
    const birthMonth = document.querySelector(
      '#user_registration_form_birth_month'
    ).value
    if (birthMonth) {
      this.birthMonth = birthMonth
    }
    const birthDay = document.querySelector('#user_registration_form_birth_day')
      .value
    if (birthDay) {
      this.birthDay = birthDay
    }
    const informationMail = document.querySelector('#receive_information_mail')
      .value
    if (informationMail === 'false') {
      this.isInformationMailChecked = false
    }
    const usableGiftNotification = document.querySelector(
      '#receive_usable_gift_mail'
    ).value
    if (usableGiftNotification === 'false') {
      this.isUsableGiftChecked = false
    }
  },
  computed: {
    isNicknameInputted() {
      return this.nickname.length !== 0
    },
    isEmailInputted() {
      return this.email.length !== 0
    },
    isGenderSelected() {
      return ['0', '1', '2'].includes(this.gender)
    },
    isBirthDayEmpty() {
      return (
        !this.isBirthYearSelected &&
        !this.isBirthMonthSelected &&
        !this.isBirthDaySelected
      )
    },
    isBirthDateCompleted() {
      return (
        this.isBirthYearSelected &&
        this.isBirthMonthSelected &&
        this.isBirthDaySelected
      )
    },
    isBirthYearSelected() {
      return this.birthYear !== ''
    },
    isBirthMonthSelected() {
      return this.birthMonth !== ''
    },
    isBirthDaySelected() {
      return this.birthDay !== ''
    },
    isSubmittable() {
      return (
        this.isEmailInputted &&
        this.isNicknameInputted &&
        this.isGenderSelected &&
        (this.isBirthDayEmpty || this.isBirthDateCompleted)
      )
    }
  },
  methods: {
    onFocusNickname() {
      this.isNicknameFocused = true
    },
    onBlurNickname() {
      this.isNicknameFocused = false
    },
    onFocusEmail() {
      this.isEmailFocused = true
    },
    onBlurEmail() {
      this.isEmailFocused = false
    },
    checkInformationMail() {
      this.isInformationMailChecked = !this.isInformationMailChecked
    },
    checkUsableGift() {
      this.isUsableGiftChecked = !this.isUsableGiftChecked
    },
    enterError() {
      setTimeout(() => {
        this.hasErrors = false
      }, 3000)
    }
  }
}
